module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA9.6cc676c0.jpg";